<template>
  <v-card>
    <v-card-title class="text-h5 align-center bb-1">
      <v-icon class="pr-2" color="secondary">mdi-translate</v-icon>
      {{ $t('Enqueue Listings Translations') }}
      <v-spacer />
      <v-btn icon @click="onClose">
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text class="py-5">
      <p class="text-body-1 mb-4">
        {{
          $t(
            'Select which fields you want to translate for all active listings:'
          )
        }}
      </p>

      <v-checkbox
        v-model="selectedTypes"
        label="Marketing Content"
        value="marketing"
        hide-details
        class="mb-2"
      >
        <template #label>
          <div>
            <div class="font-weight-medium">{{ $t('Marketing Content') }}</div>
            <div class="text-caption grey--text">
              {{ $t('Summary, Space, Access, Notes, House Rules, etc.') }}
            </div>
          </div>
        </template>
      </v-checkbox>

      <v-checkbox
        v-model="selectedTypes"
        label="Listing Title"
        value="title"
        hide-details
        class="mb-2"
      >
        <template #label>
          <div>
            <div class="font-weight-medium">{{ $t('Listing Title') }}</div>
            <div class="text-caption grey--text">
              {{ $t('Main property title visible to guests') }}
            </div>
          </div>
        </template>
      </v-checkbox>

      <v-alert
        v-if="selectedTypes.length === 0"
        type="warning"
        text
        dense
        class="mt-4"
      >
        {{ $t('Please select at least one field to translate') }}
      </v-alert>

      <v-alert type="info" text dense class="mt-4">
        <div class="text-caption">
          {{ $t('This will create translation jobs for all active listings.') }}
          {{
            $t(
              'The process may take several minutes depending on the number of listings.'
            )
          }}
        </div>
      </v-alert>
    </v-card-text>
    <v-divider />
    <v-card-actions class="justify-space-between pa-4">
      <v-btn depressed @click="onClose">
        {{ $t('Cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        depressed
        :disabled="selectedTypes.length === 0 || loading"
        :loading="loading"
        @click="enqueueTranslations"
      >
        {{ $t('Enqueue Translations') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/axios/config'
import Toaster from '@/utils/toaster'

export default {
  name: 'EnqueueTranslationsModal',
  data() {
    return {
      selectedTypes: [],
      loading: false,
    }
  },
  methods: {
    onClose() {
      this.$store.commit('hideModal')
    },
    async enqueueTranslations() {
      if (this.selectedTypes.length === 0) return

      this.loading = true
      try {
        const { data } = await axios.post(
          '/api/booking-engine-settings/enqueue-marketing-translations',
          { selected_types: this.selectedTypes }
        )

        Toaster.show([
          {
            text: data.response_message,
            type: 'success',
          },
        ])

        this.onClose()
      } catch (error) {
        console.error('Error enqueuing translations:', error)
        Toaster.show([
          {
            text:
              error.response?.data?.error ||
              this.$t('Failed to enqueue translations'),
            type: 'error',
          },
        ])
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() .v-input--checkbox {
  margin-top: 0;
}
</style>
